export * from './ActorFunctionFactoryTermLang';
